import { render, staticRenderFns } from "./aderenti.vue?vue&type=template&id=06b05d74&"
import script from "./aderenti.vue.ts?vue&type=script&lang=ts&"
export * from "./aderenti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports